@if (headers().length === 1) {
  <app-header
    [transparentNav]="headers()[0].transparentImage"
    [subtitle]="headers()[0].subtitle"
    [title]="headers()[0].title"
    [text]="headers()[0].intro"
    [image]="headers()[0].image"
    [button]="headers()[0].button"
    [isSlider]="false"
  ></app-header>
} @else {
  <swiper-container
    #swiper
    navigation="false"
    effect="fade"
    fade-effect-cross-fade="true"
    loop="{{ isBrowser ? 'true' : 'false' }}"
    speed="800"
    grabCursor="true"
    (swiperrealindexchange)="indexChange($event)"
  >
    @for (header of headers(); track $index) {
      <swiper-slide class="swiper-slide">
        <app-header
          [transparentNav]="header.transparentImage"
          [subtitle]="header.subtitle"
          [title]="header.title"
          [text]="header.intro"
          [image]="header.image"
          [button]="header.button"
          [isSlider]="true"
        ></app-header>
      </swiper-slide>
    }

    <footer slot="container-end" class="swiper__bottom">
      <div class="container d-flex justify-content-end align-items-center">
        <button class="is--prev button button-link button--light" (click)="slidePrev()" [class.set--inactive]="!activeSlide()">
          <app-icon title="vorige slide" class="icon-xxs" anchor="icon-chevron-left-xs"></app-icon>
        </button>

        <div class="swiper-pagination type-body-xs mx-1">
          <strong>{{ activeSlide() + 1 }}&nbsp;</strong>
          <span>/ {{ headers().length }}</span>
        </div>
        <button
          class="is--next button button-link button--light"
          (click)="slideNext()"
          [class.set--inactive]="activeSlide() + 1 >= headers().length"
        >
          <app-icon title="volgende slide" class="icon-xxs" anchor="icon-chevron-right-xs"></app-icon>
        </button>
      </div>
    </footer>
  </swiper-container>
}
